module.exports = __webpack_public_path__ + "media/images/icon__point--default-202e482abc8fc0b743ccc4a197115a07.png";